import httpClientBoards from '../api/httpClientBoards';

export const getBoardInfo = async () => {
  const response = await httpClientBoards.get('/api/cms/BoardInfoManagement/Get');
  return response.data;
};

export const updateBoardInfo = async (payload) => {
  const response = await httpClientBoards.put('/api/cms/BoardInfoManagement/Update', payload);
  return response.data;
};

export default {
  getBoardInfo,
  updateBoardInfo,
};

